// extracted by mini-css-extract-plugin
export var button = "_1j-0";
export var buttonContent = "_1j-e";
export var buttonGroup = "_1j-c";
export var dontRestrainIconWidth = "_1j-a";
export var dropdownButton = "_1j-b";
export var iconContainer = "_1j-9";
export var lg = "_1j-4";
export var md = "_1j-3";
export var pending = "_1j-f";
export var sm = "_1j-2";
export var spinner = "_1j-d";
export var squared = "_1j-8";
export var wrapText = "_1j-g";
export var xl = "_1j-5";
export var xs = "_1j-1";
export var xxl = "_1j-6";
export var xxxl = "_1j-7";